// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectStorageTypeQueryResult, selectStorageTypesPageLoading, selectStorageTypesShowInitWaitingMessage} from '../_selectors/storage-type.selectors';

export class StorageTypesDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectStorageTypesPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectStorageTypesShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectStorageTypeQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
